import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type StoreStorageItemData = {};

export const initialStoreStoragePageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
